<div class="columns is-multiline" [formGroup]="invoicingForm">
  <div class="column is-12">
    <h3>Facturación</h3>
    @if (
      client.personType === "PHYSICAL_PERSON" &&
      client.relationType === "RECURRENT"
    ) {
      <h4>Parámetros de facturación</h4>
    }
  </div>
  @if (
    client.personType === "PHYSICAL_PERSON" &&
    client.relationType === "RECURRENT"
  ) {
    <div class="column is-6 form-container">
      <span class="label">Forma de pago</span>
      <p-dropdown
        [options]="clientConstants.PAYMENT_TYPES"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar forma de pago"
        formControlName="paymentType"
        [emptyFilterMessage]="'No se encontraron resultados'"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Días de pago</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="icondisplay"
        formControlName="paymentDays"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Fecha inicio de facturación</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="icondisplay"
        formControlName="invoicingStartDate"
      />
    </div>
    <!-- <div class="column is-6 form-container">
            <span class="label">Vencimiento</span>
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true"
                inputId="icondisplay" formControlName="expiration" />
        </div> -->
    <div class="column is-6 form-container">
      <span class="label">Formato facturas</span>
      <p-dropdown
        [options]="clientConstants.BILL_FORMATS"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar tipo de documento"
        formControlName="billFormat"
        [emptyFilterMessage]="'No se encontraron resultados'"
      />
    </div>
    <div class="column is-6 form-container">
      <p-checkbox
        formControlName="exemptionIVA"
        binary="true"
        inputId="exemptionIVA"
      />
      <label for="exemptionIVA">Factura con IVA exento / no sujeto</label>
    </div>
    <div class="column is-6 form-container">
      <span class="label">Tipo de exención</span>
      <p-dropdown
        [options]="clientConstants.IVA_EXEMPTION_TYPES"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar responsable"
        formControlName="exemptionTypeIVA"
      />
    </div>

    <div class="column is-6 form-container">
      <span class="label">Expediente</span>
      <p-dropdown
        [options]="clientConstants.EXPEDIENT_TYPES"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar"
        formControlName="expedient"
      />
    </div>

    <div class="column is-6 form-container">
      <span class="label">Periodicidad</span>
      <p-dropdown
        [options]="clientConstants.PERIODICITY_TYPES"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar"
        formControlName="periodicity"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Cuenta bancaria</span>
      <p-dropdown
        [options]="bankAccounts"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar cuenta bancaria"
        formControlName="iban1"
        [emptyFilterMessage]="'No se encontraron resultados'"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">SEPA</span>
      <p-dropdown
        [options]="[
          { label: 'Sí', value: true },
          { label: 'No procede', value: false },
        ]"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar"
        formControlName="sepa"
      />
    </div>
    <div class="column is-6 form-container">
      <p-checkbox
        formControlName="feeProposalAccepted"
        binary="true"
        inputId="feeProposalAccepted"
      />
      <label for="feeProposalAccepted">Propuesta de honorarios aceptada</label>
    </div>
    <div class="column is-12 form-container">
      <h4>Desglose cuota</h4>
    </div>
    <div class="column is-6 form-container">
      <span class="label">Cuota fiscal</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="fiscalFee"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Cuota contable</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="accountingFee"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Cuota laboral</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="laboralFee"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Cuota notificaciones</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="notificationsFee"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Domiciliación</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="domiciliationFee"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Libros</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="booksFee"
      />
    </div>
    <div class="column is-6 form-container">
      <span class="label">Total</span>
      <input
        class="search-input"
        type="number"
        pInputText
        formControlName="totalFee"
        readonly
      />
    </div>
    <!-- <div class="column is-12 form-container">
            <h4>Otros conceptos facturables</h4>
        </div>

        <div class="column is-6 form-container">
            <span class="label">Concepto</span>
            <input class="search-input" type="text" pInputText formControlName="concept" />
        </div>
        <div class="column is-6 form-container">
            <span class="label">Cuota</span>
            <input class="search-input" type="number" pInputText formControlName="fee" />
        </div> -->
    <div class="column is-12 form-container">
      <h4>Observaciones facturación</h4>
      <textarea
        class="textarea observations-field"
        pInputTextarea
        [autoResize]="true"
        formControlName="observations"
        rows="3"
        maxlength="2000"
      ></textarea>
    </div>
  } @else if (client.personType === "PHYSICAL_PERSON") {
    <div class="column is-6 form-container">
      <span class="label">Cuenta bancaria</span>
      <p-dropdown
        [options]="bankAccounts"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar cuenta bancaria"
        formControlName="iban1"
        [emptyFilterMessage]="'No se encontraron resultados'"
      />
    </div>
  }
</div>
<div class="save-button-container">
  <button class="button save-button is-secondary" (click)="save()">
    <fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar
  </button>
</div>

@if (isSaved) {
  <div class="notification is-success">
    <!-- <button class="delete" (click)="isSaved = false"></button> -->
    <div class="notification-text">Guardado correctamente.</div>
    <div class="progress-bar-container">
      <progress
        class="progress is-small"
        min="0"
        max="100"
        #progressBar
      ></progress>
    </div>
  </div>
}
